import styled from 'styled-components';
import EventTitleHeadline from 'common/components/TouchpointEditor/components/TouchpointNodes/Headline/SubTypes/EventTitleHeadline/EventTitleHeadline';

const EventTitle = styled(EventTitleHeadline)`
    padding: 0;
`;

export default EventTitle;
